import { useEffect, useState } from "react";
import { SupportApiService } from "../../Service/SupportApiService";
import VisibilityIcon from "@mui/icons-material/Visibility";

interface RequestDetailsProps {
  id: string; // request ID
  onView: (requestType: string, id: string) => void;
}

const RequestDetails = ({ id, onView }: RequestDetailsProps) => {
  const [details, setDetails] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (!id) return;

    const fetchDetails = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await SupportApiService.getRequestDetailsById(id);
        setDetails(response.data);
      } catch (err) {
        console.error("Error fetching request details:", err);
        setError("Failed to load details");
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [id]);

  // Determine the type from fetched details
  const selectedType = details?.requestType; // assuming API returns requestType

  return (
    <span className="flex items-center gap-2">
      {loading ? (
        <span>Loading...</span>
      ) : error ? (
        <span className="text-red-500">{error}</span>
      ) : details ? (
        <>
              <p className="content-title">
                Request Number
              </p>
              <div className="title-bottom-line"></div>
              <p className="content-text d-inline-block me-2">{details.requestNumber}</p>
        {/* <span>
          {details.requestNumber}{" "}
          {details.totalBarrels ? `- (${details.totalBarrels}) Barrels` : ""}
        </span> */}
     </> ) : (
        <span>No details</span>
      )}

      <span
        onClick={(e) => {
          e.stopPropagation();
          if (selectedType) onView(selectedType, id);
        }}
        style={{ cursor: "pointer" }}
      >
        <VisibilityIcon sx={{ color: "#3A809E"}}/>
      </span>
    </span>
  );
};

export default RequestDetails;
